import React from 'react'
import {checkRoom} from '../firebase'
import {Redirect} from 'react-router-dom'

class NewRoom extends React.Component {

  constructor() {
    super() 
    this.state = {
      room_code: "",
      redirect: false, 
      errorText: ""
    }
  }

  onCodeFieldChanged = (event) => {
    this.setState({room_code: event.target.value})
  }

  gotoRoom = () => {
    let validName = this.roomValidator()
    if(validName) {
      checkRoom(this.state.room_code).once('value', snapshot => {
        if(snapshot.val() == null) {
          this.setState({redirect: true})
        } else {
          this.setState({errorText: "This room name is unavailable"})
        }
      })
    } else {
      this.setState({errorText: "Room names can only contain letters and numbers"})
    }
  }

  roomValidator() {
    if(this.state.room_code=="") {
      return false
    }
    let letterNumbers = /^[0-9a-zA-Z]+$/

    if(this.state.room_code.match(letterNumbers)) {
      return true
      
    } else {
      return false
    }
  }

  render() {
    if(this.state.redirect) {
      return (<Redirect to={`/room/${this.state.room_code}`}/>)
    } else {
      return (
        <div className="NewRoom p-4">
          <h4>Create a new Synchonus room</h4>
          <div className="input-group mb-3">
            <input type="text" className="form-control" placeholder="Room name" value={this.state.room_code} onChange={this.onCodeFieldChanged}/>
          </div>
          <div className="small text-danger mb-3">{this.state.errorText}</div>
          <button className="btn btn-success" onClick={this.gotoRoom}>Let's go!</button>
        </div>
      )
    }
    
  }
}
export default NewRoom